// extracted by mini-css-extract-plugin
export var subtitle = "_9f-2";
export var title = "_9f-0";
export var titleNoWrap = "_9f-1";